/** Lucide icon variant for a landing-page customer use case card. */
export enum ExampleUseCaseIconEnum {
  /** Journey stalls, drop-offs, and UX gaps. */
  DIAGNOSE = "DIAGNOSE",
  /** Acquisition and conversion paths. */
  GROWTH = "GROWTH",
  /** Safe releases and regression coverage. */
  RELEASE = "RELEASE",
}
